import { Component, OnInit, Inject } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-online-enquiry-log',
  templateUrl: './online-enquiry-log.component.html',
  styleUrls: ['./online-enquiry-log.component.scss']
})
export class OnlineEnquiryLogComponent implements OnInit {
  rid: any;
  enquiry_log_data: any =  [];
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  constructor(private dialogRef: MatDialogRef<OnlineEnquiryLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private dialog: MatDialog) {
    console.log(data);
    this.rid = data['rid'];
    this.serveEnquiryLog();

  }

  checkBorderColor(status_name) {
    if (status_name === 'Success') {
      return '20px solid green';
    } else if (status_name === 'Failed') {
      return '20px solid red';
    } else if (status_name === 'Pending') {
      return '20px solid yellow';
    } else {
      return '20px solid gray';
    }
  }

  closeClicked() {
    this.dialogRef.close();
  }

  serveEnquiryLog() {
    let data_dict = {
      'rid': this.rid
    };
    this.is_data_available = false;
    this.httpService.serveEnquiryRequestLog(data_dict).subscribe((data) => {
      console.log(data);
      this.enquiry_log_data = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }

  makeEnquiry() {
    let data_dict = {
      'rid': this.rid
    };
    this.is_data_available = false;

    this.httpService.makeEnquiryFromPortal(data_dict).subscribe((data) => {
      console.log(data);
      this.serveEnquiryLog();
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }

  ngOnInit() {
  }

}
